export function setToken(state, token) {
  state.token = token;
}

export function addParticipants(state, participants) {
  participants.forEach((participant) => {
    const found = state.allParticipants.find((p) => +p.id === +participant.id);
    if (!found) {
      state.allParticipants.push(participant);
    }
  });
}

export function removeAllParticipants(state) {
  state.allParticipants = [];
}

export function addPendingParticipantId(state, id) {
  if (!state.pendingParticipantIds.includes(+id)) {
    state.pendingParticipantIds.push(+id);
  }
}

export function removePendingParticipantId(state, id) {
  state.pendingParticipantIds = state.pendingParticipantIds.filter((pId) => +pId !== +id);
}
